import { css } from 'foundations-theming/utils';
/**
 * Edge 18 and Safari 11 do not support :focus-visible, so we need fallback to
 * :focus for those browsers to ensure some focus styles are applied.
 * https://caniuse.com/?search=%3Afocus-visible
 */
function supportsFocusVisible() {
  return window.CSS && CSS.supports && CSS.supports('selector(:focus-visible)');
}
export const getFocusPseudoClass = () => {
  return supportsFocusVisible() ? '&&:focus-visible' : '&&:focus';
};
export const getFocusStyleObject = ({
  theme,
  addBorderRadius,
  unwrapped,
  override
}) => {
  const styles = Object.assign({
    borderColor: 'transparent !important',
    outline: `${theme.borderWidth['200']} solid ${theme.color['border-info-default']} !important`,
    outlineOffset: `calc(${theme.borderWidth['200']} * -1)`,
    boxShadow: `inset 0 0 0 ${theme.borderWidth['200']} ${theme.color['border-core-on-fill-default']} !important`
  }, addBorderRadius && {
    borderRadius: theme.borderRadius['100']
  });
  if (override) {
    return {
      borderColor: 'inherit !important',
      boxShadow: 'none !important',
      outline: 'none !important'
    };
  }
  if (unwrapped) {
    return styles;
  }
  return {
    [getFocusPseudoClass()]: styles
  };
};
export const getFocusStyle = ({
  theme,
  addBorderRadius,
  unwrapped,
  override
}) => css(getFocusStyleObject({
  theme,
  addBorderRadius,
  unwrapped,
  override
}));